// extracted by mini-css-extract-plugin
var _1 = "details-text___ExNVZ";
export { _1 as "details-text" }
